<template>
    <div>
        <ol class="hidden md:flex items-center">
            <template v-for="(link, i) in links">
                <li v-if="i" class="inline-flex px-1">
                    <font-awesome-icon icon="chevron-right" size="xs"/>
                </li>
                <li class="px-1 first:pl-0">
                    <router-link
                        :to="link.to" active-class="text-gray-700 cursor-default hover:text-gray-700">
                        {{ link.label }}
                    </router-link>
                </li>
            </template>
        </ol>
        <div v-if="links.length > 1" class="flex items-center md:hidden">
            <div class="inline-flex">
                <font-awesome-icon icon="chevron-left" size="xs"/>
            </div>
            <router-link
                :to="upLink.to" class="ml-2">
                {{ upLink.label }}
            </router-link>
        </div>
    </div>
</template>

<script>

export default {

    name: "Breadcrumbs",

    props: {
        links: Array
    },

    computed: {
        upLink() {
            if (this.links.length > 1) {
                return this.links[this.links.length - 2];
            }
        },
    }
};

</script>
